import { render, staticRenderFns } from "./SetBalance.vue?vue&type=template&id=17821e5d&scoped=true"
import script from "./SetBalance.vue?vue&type=script&lang=js"
export * from "./SetBalance.vue?vue&type=script&lang=js"
import style0 from "./SetBalance.vue?vue&type=style&index=0&id=17821e5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17821e5d",
  null
  
)

export default component.exports